import React from "react";

import { ThemeProvider as MyThemeProvider } from "styled-components";
import { theme } from "../themes/cashrent/theme";

export const ThemeProvider = ({ children }) => <MyThemeProvider theme={theme}>{children}</MyThemeProvider>;
